<app-base-modal
  [title]="'Масс рассылка'"
>
  <form
    class="container"
    [formGroup]="massOffersForm"
  >
    @for (field of massOffersFormFields; track $index) {
      @switch (field.type) {
        @case ('select') {
          <mat-form-field
            appearance="outline"
            class="form-field"
          >
            <mat-label>{{ field.label }}</mat-label>
            <mat-select [formControlName]="field.fieldName">
              @for (option of productSelectData; track $index) {
                <mat-option [value]="option.id">
                  {{ option.value }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @case ('textarea') {
          <mat-form-field
            appearance="outline"
            class="form-field"
          >
            <mat-label>{{ field.label }}</mat-label>
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="7"
              cdkAutosizeMaxRows="7"
              placeholder="Введите сообщение"
              [formControlName]="field.fieldName"
            ></textarea>
          </mat-form-field>
        }
      }
    }
  </form>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      [disabled]="isDisabledBtn()"
      (click)="handleSendMessage()"
    >
      Отправить
    </button>
    <button
      mat-button
      tabindex="-1"
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
